import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { environment } from '@coin/shared/core/util-environments';
import { BudgetAllocationSettings, SeasonPublicationSettingsService } from '@coin/shared/core/util-models';
import { ToastrService } from 'ngx-toastr';
import { iif, Observable, of } from 'rxjs';
import { finalize, mergeMap, tap } from 'rxjs/operators';
import { HttpHelpersService, LoadingService } from '@coin/shared/core/data-access';

@Injectable({
  providedIn: 'root'
})
export class BudgetAllocationService implements SeasonPublicationSettingsService {
  private readonly httpClient = inject(HttpClient);
  private readonly loadingService = inject(LoadingService);
  private readonly toast = inject(ToastrService);
  private readonly httpHelpersService = inject(HttpHelpersService);

  public getSettings(seasonId: string): Observable<BudgetAllocationSettings> {
    this.loadingService.present();
    return this.httpClient
      .get<BudgetAllocationSettings>(
        `${environment.api.baseUrl}/admin/api/v2/master/seasons/${seasonId}/merit-allocation-settings`
      )
      .pipe(
        this.httpHelpersService.handleError('Cannot load budget allocation settings'),
        finalize(() => this.loadingService.dismiss())
      );
  }

  public save(body: BudgetAllocationSettings, seasonId: string): Observable<BudgetAllocationSettings> {
    this.loadingService.present();
    return of('').pipe(
      mergeMap(() => iif(() => !!body.id, this.patch(body, seasonId), this.post(body, seasonId))),
      this.httpHelpersService.handleError('Cannot save budget allocation settings'),
      tap(() => {
        this.toast.success('Budget Allocation Settings saved.');
      }),
      finalize(() => this.loadingService.dismiss())
    );
  }

  private patch(body: BudgetAllocationSettings, seasonId: string): Observable<BudgetAllocationSettings> {
    return this.httpClient.patch<BudgetAllocationSettings>(
      `${environment.api.baseUrl}/admin/api/v2/master/seasons/${seasonId}/merit-allocation-settings`,
      body
    );
  }

  private post(body: BudgetAllocationSettings, seasonId: string): Observable<BudgetAllocationSettings> {
    return this.httpClient.post<BudgetAllocationSettings>(
      `${environment.api.baseUrl}/admin/api/v2/master/seasons/${seasonId}/merit-allocation-settings`,
      body
    );
  }
}
